import { Component, Input, OnInit } from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import { ApiService } from '../services/api.service';
import { InternalService } from '../services/internal.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ImageViewerModalComponent} from '../modals/image-viewer-modal/imageViewerModal..component';

@Component({
  selector: 'app-user-card',
  templateUrl: './userCard.component.html',
  styleUrls: ['./userCard.component.css'],
})
export class UserCardComponent implements OnInit {
  @Input() user: any = [];
  // image;
  @Input() back;
  modalContent: any;

  constructor(
    public internalService: InternalService,
    public apiService: ApiService,
    private ngbModal: NgbModal,
    public matDialog: MatDialog,
  ) {}

  ngOnInit() {
    this.internalService.getMd5(this.user.profilePic).then((result) => {
      this.user.techImage = result;
    });

    if (this.user.idCard) {
      this.internalService.getMd5(this.user.idCard.image).then((result) => {
        this.user.idCard.idCardImage = result;
      });
    }
    if (this.user.technicnianInfo.certificateInfo.image !== '') {
      this.internalService
        .getMd5(this.user.technicnianInfo.certificateInfo.image)
        .then((result) => {
          this.user.certificateInfo.certificateInfo.base64 = result;
        });
    }

    if (this.user.technicnianInfo.confirmations.length > 0) {
      for (let item of this.user.technicnianInfo.confirmations) {
        this.internalService.getMd5(item.icon).then((result) => {
          item.iconImage = result;
        });
      }
    }
  }

  open(content, section, size) {
    // open addEditDel in large size

       this.modalContent = section;
      this.ngbModal.open(content, {
        windowClass: 'addEditDel-holder',
        centered: true,
        size: size,
      });


  }


}
